// extracted by mini-css-extract-plugin
export default {"container":"SearchPopUpBody_container__1-BB1","senderName":"SearchPopUpBody_senderName__ZZEG-","messagesText":"SearchPopUpBody_messagesText__NNCIT"};